/* eslint-disable prettier/prettier */
import { setStoreValue } from '@/store/utils';

export const SET_IS_FETCHING_AVAILABLE_CANDIDATES = 'SET_IS_FETCHING_AVAILABLE_CANDIDATES';
export const SET_AVAILABLE_CANDIDATES = 'SET_AVAILABLE_CANDIDATES';
export const SET_APPLICATION_COMMENTS = 'SET_APPLICATION_COMMENTS';
export const SET_IS_LOADING_APPLICATION_COMMENTS = 'SET_IS_LOADING_APPLICATION_COMMENTS';
export const SET_BOOKING_APPLICATION_QUESTIONS = 'SET_BOOKING_APPLICATION_QUESTIONS';
export const SET_IS_LOADING_APPLICATION_QUESTIONS = 'SET_IS_LOADING_APPLICATION_QUESTIONS';
export const SET_IS_FETCHING_CURRENT_USER_APPLICATION = 'SET_IS_FETCHING_CURRENT_USER_APPLICATION';
export const SET_CURRENT_USER_APPLICATION = 'SET_CURRENT_USER_APPLICATION';
export const SET_IS_FETCHING_ALL_APPLICATIONS = 'SET_IS_FETCHING_ALL_APPLICATIONS';
export const SET_ALL_APPLICATIONS = 'SET_ALL_APPLICATIONS';
export const SET_CURRENT_APPLICATION = 'SET_CURRENT_APPLICATION';
export const SET_IS_FETCHING_CURRENT_APPLICATION = 'SET_IS_FETCHING_CURRENT_APPLICATION';
export const SET_CURRENT_APPLICATION_ANSWERS = 'SET_CURRENT_APPLICATION_ANSWERS';
export const SET_IS_FETCHING_CURRENT_APPLICATION_ANSWERS = 'SET_IS_FETCHING_CURRENT_APPLICATION_ANSWERS';

const applicationsMutations = {
  [SET_IS_FETCHING_AVAILABLE_CANDIDATES]: setStoreValue("isFetchingAvailableCandidates"),
  [SET_AVAILABLE_CANDIDATES]: setStoreValue("availableCandidates"),
  [SET_APPLICATION_COMMENTS]: setStoreValue("applicationComments"),
  [SET_IS_LOADING_APPLICATION_COMMENTS]: setStoreValue("isLoadingApplicationComments"),
  [SET_IS_LOADING_APPLICATION_QUESTIONS]: setStoreValue("isLoadingApplicationQuestions"),
  [SET_BOOKING_APPLICATION_QUESTIONS]: setStoreValue("bookingApplicationQuestions"),
  [SET_IS_FETCHING_CURRENT_USER_APPLICATION]: setStoreValue("isFetchingCurrentUserApplication"),
  [SET_CURRENT_USER_APPLICATION]: setStoreValue("currentUserApplication"),
  [SET_IS_FETCHING_ALL_APPLICATIONS]: setStoreValue("isFetchingAllApplications"),
  [SET_ALL_APPLICATIONS]: setStoreValue("allApplications"),
  [SET_CURRENT_APPLICATION]: setStoreValue("currentApplication"),
  [SET_IS_FETCHING_CURRENT_APPLICATION]: setStoreValue("isFetchingCurrentApplication"),
  [SET_IS_FETCHING_CURRENT_APPLICATION_ANSWERS]: setStoreValue("isFetchingCurrentApplicationAnswers"),
  [SET_CURRENT_APPLICATION_ANSWERS]: setStoreValue("currentApplicationAnswers")
};

export default applicationsMutations;
